<template>
<div class="content">


<div class="row center item"  @click="url('/user/team')">
    <div class="img">
        <img src="../../images/team.png" alt="团检预约">
    </div>
    <div class="title1">公司体检预约</div>
    <div class="sub-title">(企业付款)</div>
</div>

<div class="row center item item2"  @click="url('/user/person/1')">
    <div class="img">
        <img src="../../images/person.png" alt="个检预约">
    </div>
    <div class="title2">个人体检预约</div>
    <div class="sub-title">(个人付款)</div>
</div>

</div>
</template>

<style scoped>
.content{
    width:100%;
    float:left;
    height:100%;
    background:#eee;
}
.item{
    background:white;
    width:94%;
    margin:1.5vh 3% 0;
    height:44vh;
    border-radius: .5rem;
}
.item2{
    margin-bottom:1.5vh;
}
.title1{
    color:rgb(0,202,181);
}
.title2{
    color:rgb(252,172,12);
}
.sub-title{
    color:#bbb;
}
</style>


<script>
export default {
    created(){
        this.$emit("setTitle","体检预约");
    },
    methods:{
        url:function(url){
        this.$router.push(url);
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/user/book.vue